import _ from 'lodash';
import { genId, isOnline, base64ToBlob, getUrlParams } from '../../util';
import StoreService from '../../services/api/base.cookie';
import Api from '../../services/api';
import CONSTANT from '../../constant';
import ProjectAction from '../project/action';
import ExtensionAction from '../extension/action';
import ProjectService from '../../services/api/project';
import MscratchService from '../../services/mscratch';
import { isCodeyLoaded } from '../../services/mscratch/ext';
import RouterService from '../../services/api/router';
import Emitter from '../../services/emitter';
import History from '../../util/history';
import { message } from 'antd/lib/index';
import projectModel from '../../model/project.model';
import LanguageAction from '../language/action';
import ProjectOss from '../../services/api/project-oss';
import Progress from 'src/util/progress';
import config from '../../config';
import { setPageThumbnail } from '../../reducers/listeners/common';
import {
    SYNC_PROJECTS, UPLOAD_PROJECT, CLEAR_PROJECTS, DOWNLOAD_PROJECT
} from './actionTypes';

let firstSync = true;
let cacheProject = {};

export default class ActionWeb {
    constructor(store) {
        this.store = store;
    }

    async syncList(successCb, failCb) {
        if (config.showCopyrightLogo) return;
        const store = this.store;
        const { account, project } = store.getState();
        const { projectId } = project;
        ProjectAction.syncMsg(store, CONSTANT.PROJECT_SYNC_STATUS['SYNCING']);
        // 获取我的云端作品列表
        let myCloudList = [];
        if (account.isLogin) {
            try {
                await Api.ProjectService.get_cloud_projects({
                    '_HEADER_': { 'utoken': StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY) }
                }).then(res => {
                    myCloudList = res.cloudProjectList.map((c) => {
                        return { ...c, projectId: c.id, isDeleted: c.isDeleted === 1, isShare: c.isShare === 1 };
                    });
                    ProjectService.syncWebList(myCloudList);
                    successCb && successCb(myCloudList);
                });
            } catch (error) {
                myCloudList = [];
                ProjectAction.syncMsg(store, CONSTANT.PROJECT_SYNC_STATUS['NONETWORK']);
                failCb && failCb(error);
            }
        }

        const isSelfProject = ProjectService.isSelfProject(projectId);
        const isShare = isSelfProject ? ProjectService.hasShared(myCloudList, projectId) : true;
        projectModel.initName(myCloudList);
        if (firstSync) {
            firstSync = false;
            this.updateRemoteProjectFromUrl();
        }
        projectModel.setProSelfAndShare(isSelfProject, isShare);
        store.dispatch({ type: SYNC_PROJECTS, payload: { projects: myCloudList } });
    }

    async NewProject() {
        if (projectModel.isSaved()) {
            MscratchService.clear();
            // 新建项目时如果没有codey扩展则加载codey
            if (!isCodeyLoaded()) {
                Emitter.emit('ExtsFound', { exts: ['codey'] });
            }
            History.push({
                pathname: '/'
            });
            projectModel.createNewProject('list');
            this.store.dispatch(ProjectAction.saved({isConfirmName: false}));
        } else {
            this.saveProjectCache();
            if (History.location.pathname !== '/confirm/save/new') {
                History.push({
                    pathname: '/confirm/save/new'
                });
            }
        }
    }

    async OpenProject(file, projectInfo = {}) {
        const { project, intlr } = this.store.getState();
        const { projects } = project;
        const { messages } = intlr;
        if (projectModel.isSaved()) {
            // 清除Mscratch的侧边栏
            MscratchService.clearLayout();
            projectModel.setLoadingPageState(true);
            this.store.dispatch(ProjectAction.saved({isConfirmName: true}));
            const defaultShowDialogOptions = {
                title: messages['PROJECT.SHOW.DIALOG.TITLE'],
                filters: [
                    {
                        name: messages['PROJECT.DIALOG.FILTER.NAME'],
                        extensions: CONSTANT.PROJECT_SUFFIX
                    }
                ],
                properties: ['openFile']
            };
            let projectName = projectInfo.cacheName || projectInfo.name || project.name;
            projectModel.setProSelfAndShare(true, false);
            if (typeof file == 'number') {
                this.loadProjectById(file);
                const isSelfPro = ProjectService.isSelfProject(file);
                const isShare = ProjectService.hasShared(projects, file);
                projectModel.setProSelfAndShare(isSelfPro, isShare);
            } else if (project.projectType === 'example' || projectInfo.cacheName) {
                this.loadExample(file, projectName);
            } else {
                try {
                    const res = await MscratchService.import(file || project.file, defaultShowDialogOptions);
                    if (res) {
                        const filePath = res.filePath;
                        projectName = filePath
                            ? filePath.substring(0, filePath.lastIndexOf('.'))
                            : projectName;
                        let projectType = projectInfo.hasOwnProperty('projectType')
                            ? projectInfo['projectType']
                            : CONSTANT.PROJECT_TYPE['LIST'];
                        projectName = ProjectService.getNewProjectName(projectName, projects);
                        this.loadProjectByFileData(projectName, '', res.data, projectType);
                        if (History.location.pathname !== '/') {
                            History.push({
                                pathname: '/'
                            });
                        }
                    }
                } catch(error) {
                    throw new Error('error');
                }
            }
            History.replace('/');
        } else {
            projectModel.setCurrentFile(file);
            await this.saveProjectCache();
            RouterService.gotoPath('/confirm/save/open');
        }
    }

    async loadProjectById (projectId) {
        let pid = projectId;
        let info = ProjectService.getProject(pid);
        if(!info) {
            info = await ProjectService.fetchProjectById(pid);
        }
        const {commitId, projectName, id, projectData} = info;

        if(projectData) {
            // 本地缓存了用户数据
            this.loadProjectByFileData(projectName, pid, projectData);
        } else {
            try {
                // 本地没有缓存，从云端获取项目
                if (!this.checkNetWork()) return;
                let data = await ProjectService.fetchProjectData(commitId, projectName, id, projectId);
                this.loadProjectByFileData(projectName, projectId, data);
            } catch (e) {
                console.error(e);
            }
        }
    }

    loadProjectByFileData(name, projectId, fileData, projectType) {
        this.ReadedFile(null, fileData, {
            name: name,
            projectId,
            projectType: projectType || CONSTANT.PROJECT_TYPE['LIST']
        });
    }

    async SaveProject(isSaveas, projectInfo = {}, successCallback) {
        // 判断保存状态
        if(!this.checkIsLogin() || saveStatus === CONSTANT.PROJECT_SAVE_STATUS['DOING']) return;
        projectModel.setProjectSaveStatus('DOING');

        // 获取项目的数据
        let projectData = cacheProject.projectData || await MscratchService.getProjectJson();
        if (!projectData || projectData.size < 1000) {
            projectModel.saveError();
            return;
        }

        this.projectOss = new ProjectOss();
        let uploadProjectProgress = new Progress({
            size: projectData.size,
            timeout: CONSTANT.PROJECT_SAVE_TIMEOUT,
            onupdated: value => {
                projectModel.saveProjectProgress(value);
            },
            onerror: (err) => {
                // TODO: 这里需要取消上传, oss中有abortUpload
                projectModel.saveError(err);
            }
        });
        let uploadCoverImgProgress = new Progress();
        uploadProjectProgress.addChild(uploadCoverImgProgress);

        const _id = genId();
        const coverImage = await this.SaveProjectCover(uploadCoverImgProgress);
        if (!coverImage) return;
        // 将作品封面图设置为页面分享出去的缩略图
        setPageThumbnail(coverImage);
        const store = this.store;
        const { project } = store.getState();
        let { id, projectId, saveStatus, projects, isSelfProject, isShare } = project;
        // 项目名称
        let name = cacheProject.name || projectInfo.name || project.name;
        isSelfProject = _.has(projectInfo, 'isSelfProject') ? projectInfo.isSelfProject : isSelfProject;
        name = !isSelfProject ? projectInfo.name : name;
        isShare = _.has(projectInfo, 'isShare') ? projectInfo.isShare : isShare;
        projectId = _.has(projectInfo, 'projectId') ? projectInfo.projectId : projectId;

        const projectIds = projects.map(p => p.projectId);
        const createdAt = Date.parse(new Date()) / 1000;
        const type = !isSaveas && (_.indexOf(projectIds, parseInt(projectId)) > -1) ? 'update' : !isSelfProject ? 'adapt' : 'new';
        const strategies = projectModel.selectSaveOperation();
        const ret = strategies[type]({
            id,
            _id,
            createdAt,
            projectInfo,
            name,
            projectId,
            projectData,
            projects
        });

        id = ret.id;
        projectId = ret.projectId;
        projectInfo = ret.projectInfo;
        projects = ret.projects;

        store.dispatch(ProjectAction.saved({
            projects: projects
        }));

        const { projectName, localName, syncStatus } = projectInfo;

        const info = { id, projectId, projectName, localName, createdAt, syncStatus, fileName: projectName, coverImage, isSelfProject, isShare };
        await this.UploadFile(projectData, info, successCallback, uploadProjectProgress);
    }

    async SaveProjectCover(uploadCoverProgress) {
        // 获取截图
        const coverData = cacheProject.coverData || await this.getCoverData();
        uploadCoverProgress.setSize(coverData.size);

        let coverError = null;
        const progress = (percentage) => {
            console.log('****** upload cover image ******', percentage);
            uploadCoverProgress.updateValue(percentage);
        };
        try {
            const coverImgOssUrl = await this.projectOss.multipartUploadCoverImg(coverData, progress);
            if (coverImgOssUrl) {
                return coverImgOssUrl;
            }
        } catch (err) {
            coverError = err;
            console.log('upload coverImg error: ', err);
        }
        uploadCoverProgress.triggerError(coverError);
    }

    async UploadFile(projectData, info, successCallback, uploadProjectProgress) {
        this.resetProjectCache();
        const store = this.store;
        const { projects } = store.getState().project;
        const progress = (percentage) => {
            console.log('****** upload project ******', percentage);
            uploadProjectProgress.updateValue(percentage);
        };
        let uploadError = null;
        let uploadRes = null;
        try {
            uploadRes = await this.projectOss.multipartUploadProject(projectData, progress, info);
        } catch (err) {
            uploadError = err;
            console.error('upload file error', err);
        }
        // 当上传成功时
        if (uploadRes) {
            const { projectId, commitId } = uploadRes;
            projectModel.setProjectSaveStatus('SUCCESS');
            const { messages } = store.getState().intlr;
            const successMsg = messages['PROJECT.EXPORT.MYPROJECTS.MSG'];
            message.success(successMsg, 2);
            const actions = {
                origin: projects,
                dowithOrigin: projects.map(item => {
                    if(item.id === info.id){
                        item.id = projectId;
                        item.projectId = projectId;
                    }
                    return item;
                })
            };
            let succInfo = {
                projectId,
                commitId,
                preProjectData: MscratchService.getProjectJsonString(),
                projectType: CONSTANT.PROJECT_TYPE.LIST,
                name: info.projectName,
                isSelfProject: info.isSelfProject,
                isShare: info.isShare,
                projects: actions[projectId && info.isSelfProject ? 'origin' : 'dowithOrigin'],
            };

            if (!info.isSelfProject) {
                succInfo.isSelfProject = true;
                succInfo.isShare = false;
            }

            store.dispatch({
                type: UPLOAD_PROJECT,
                payload: succInfo
            });
            projectModel.saveProjectProgress(0);
            console.log('上传文件成功: ', projectId);
            successCallback && successCallback(projectId);
            return;
        }
        // 当上传失败时
        uploadProjectProgress.triggerError(uploadError);
    }

    async RenameProject(data, callback) {
        console.log('进入project->web->rename', data.projectName);
        const store = this.store;
        const { projects } = store.getState().project;
        const { projectId, projectName, createdAt } = data;
        let _projects = [];
        if (projectId) {
            try {
                Api.ProjectService.rename_project({
                    createdAt, projectName, projectId,
                    '_HEADER_': { 'utoken': StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY) }
                }).then(async () => {
                    _projects = projects.map(p => p.id === projectId ? { ...p, projectName: projectName } : p);
                    store.dispatch(ProjectAction.rename({
                        projects: _projects
                    }));
                });
            } catch (err) {
                _.isFunction(callback) && callback(err);
                return;
            }
        }
        _.isFunction(callback) && callback();
    }

    exportProject() {
        const { project } = this.store.getState();
        ProjectService.exportFromWeb(project);
    }

    async importProject(file, projectInfo = {}) {
        const store = this.store;
        const { project, intlr } = store.getState();
        const { messages } = intlr;
        if (projectModel.isSaved()) {
            const defaultShowDialogOptions = {
                title: messages['PROJECT.SHOW.DIALOG.TITLE'],
                filters: [{
                    name: messages['PROJECT.DIALOG.FILTER.NAME'],
                    extensions: CONSTANT.PROJECT_SUFFIX
                }],
                properties: ['openFile']
            };
            try {
                const res = await MscratchService.import(file || project.file, defaultShowDialogOptions);
                console.log('res:' + res.filePath);
                if (res) {
                    projectModel.setProSelfAndShare(true, false);
                    projectInfo['filePath'] = res.filePath;
                    projectInfo.projectId = '';
                    if (res.filePath.indexOf('.') > -1) {
                        projectInfo.name = ProjectService.getNewProjectName(res.filePath.substring(0, res.filePath.lastIndexOf('.')), project.projects);
                    }
                    this.ReadedFile(null, res.data, projectInfo);
                    RouterService.gotoPath('/');
                }
            } catch (error) {
                console.log(error);
            }
        } else {
            await this.saveProjectCache();
            RouterService.gotoPath('/confirm/save/import');
        }
    }

    async saveProjectCache() {
        const { project } = this.store.getState();
        let name = project.name;
        let coverData = await this.getCoverData();
        let projectData = await MscratchService.getProjectJson();
        cacheProject = {
            name, coverData, projectData
        };
        console.log(cacheProject);
    }

    resetProjectCache() {
        cacheProject = {};
        console.log(cacheProject);
    }

    /**
     * 渲染项目：项目数据，项目名称
     * @param { Object } err
     * @param { arrayBuffer } data
     * @param { Object } projectInfo
     */
    async ReadedFile(err, data, projectInfo) {
        const store = this.store;
        const {
            messages
        } = store.getState().intlr;
        const successMsg = messages['IMPORT.SUCCESS.MSG'];
        const failMsg = messages['IMPORT.FAIL.MSG'];
        if (err) {
            let msg = [failMsg];
            if (_.isObject(err) && _.has(messages, err.key)) {
                msg = [messages[err.key], failMsg];
            } else {
                msg = [err, failMsg];
            }
            message.error(msg.join(' - '));
        } else {
            const success = () => {
                const projectType = projectInfo.hasOwnProperty('projectType')
                    ? projectInfo.projectType
                    : CONSTANT.PROJECT_TYPE.LOCAL;
                projectInfo['projectType'] = projectType;
                console.log('打开项目成功: ' + projectInfo.projectId);
                store.dispatch(ProjectAction.saved({
                    ...projectInfo,
                    saveStatus: '',
                    cacheName: null
                }));
                if (projectType !== CONSTANT.PROJECT_TYPE.EXAMPLE) {
                    message.success(successMsg, 2);
                } else {
                    MscratchService.clearUpWorkspace();
                }
            };
            if (data) {
                try {
                    const exts = await MscratchService.renderProject(data, success);
                    if (exts.exts) {
                        ExtensionAction.load(exts.exts);
                    }
                } catch (error) {
                    console.warn(error);
                    message.error(failMsg);
                }
            }
        }
        store.dispatch(ProjectAction.file(null));
    }

    clearProjects() {
        const store = this.store;
        store.dispatch({ type: CLEAR_PROJECTS, payload: { projects: [] } });
    }

    savedFinishExec(type) {
        const store = this.store;
        if (!projectModel.isSaved()) {
            if (!this.checkIsLogin()) return;
            projectModel.setProjectSaveStatus('FAILURE');
            History.replace('/');
            return;
        }

        const { project } = store.getState();
        const { file, cacheName } = project;
        if (projectModel.isSaved()) {
            projectModel.setProSelfAndShareOnConfirm(project);
            this.resetProjectCache();
        }
        switch (type) {
            case 'open':
                Emitter.emit('OpenProject', file, 'web', {cacheName});
                break;
            case 'new':
                Emitter.emit('NewProject');
                break;
            case 'import':
                Emitter.emit('ImportProject');
                break;
            case 'example':
                History.replace('/list?demos');
                break;
            case 'list':
                History.replace('/list?projects');
                break;
            default:
                break;
        }
        History.replace('/');
        store.dispatch(ProjectAction.confirmType(null));
    }

    async getCoverData() {
        const base64 = await MscratchService.getProjectCoverPic();
        const blob = await base64ToBlob(base64);
        return blob;
    }

    async loadExample(data, name) {
        projectModel.setCurrentFileCacheName(data, name, CONSTANT.PROJECT_TYPE.EXAMPLE);
        if (projectModel.isSaved()) {
            projectModel.setProSelfAndShare(true, false);
            await this.ReadedFile(null, data, {
                name,
                projectId: '',
                projectType: CONSTANT.PROJECT_TYPE.EXAMPLE
            });
            RouterService.gotoPath('/');
        } else {
            this.saveProjectCache();
            RouterService.gotoPath('/confirm/save/open');
        }
    }

    checkNetWork() {
        const store = this.store;
        const { intlr } = store.getState();
        if (!isOnline()) {
            const { messages } = intlr;
            store.dispatch({
                type: DOWNLOAD_PROJECT,
                payload: { downloadStatus: { err: messages['NETWORK.ERR.MSG'], percent: 0 } }
            });
            return false;
        }
        return true;
    }

    checkIsLogin() {
        const store = this.store;
        const { isLogin } = store.getState().account;
        if(!isLogin) {
            History.replace('/login');
            return false;
        }
        return true;
    }

    async updateRemoteProjectFromUrl() {
        let params = getUrlParams() || {};
        let projectId = params.cloudProjectId || '';
        let lang = params.lang;
        if(!projectId) return;

        if(lang) {
            this.store.dispatch(LanguageAction.change(lang));
        }

        console.log('update remote project: ' + projectId);
        let info = await ProjectService.fetchProjectBaseInfoById(projectId);
        if (!info) {
            projectModel.createNewProject();
            return;
        }
        let projectInfo = {
            name: info.projectName
        };

        const {account, project} = this.store.getState();
        const { projects } = project;
        projectModel.setProjectPlatformType(projectId);
        if (account.isLogin) {
            if(ProjectService.getProject(projectId)) {
                // 自己的项目
                projectInfo.projectId = projectId;
                projectModel.setProSelfAndShare(true, ProjectService.hasShared(projects, projectId));
            } else {
                projectModel.setProSelfAndShare(false, true);
                projectInfo.preProjectData = '';
                projectInfo.projectId = projectId;
            }
        } else {
            projectModel.setProSelfAndShare(false, true);
            projectInfo.projectId = info.id;
        }
        this.store.dispatch(ProjectAction.saved(projectInfo));
    }
}